export interface SvgViewBox {
  minX: number;
  minY: number;
  width: number;
  height: number;
}

export const getSvgViewBox = (svg: string): SvgViewBox | null => {
  const parser = new DOMParser();
  const document = parser.parseFromString(svg, 'image/svg+xml');

  const viewBox = document.querySelector('svg')?.getAttribute('viewBox');

  if (viewBox) {
    const splitViewBox = viewBox.split(' ');

    return {
      // Fixed noUncheckedIndexedAccess NIM-19408
      minX: Number.parseInt(splitViewBox[0]! ?? 0, 10),
      minY: Number.parseInt(splitViewBox[1]! ?? 0, 10),
      width: Number.parseInt(splitViewBox[2]! ?? 0, 10),
      height: Number.parseInt(splitViewBox[3]! ?? 0, 10),
    };
  }
  return null;
};
